import { useState } from "react"
import { useDispatch, useSelector } from "react-redux"
import { logIn, setNeedUserLogin, setToken, setUserName } from "../../../../Reducers/default-reducers/globalConfigReducer"
import { useUserService } from "../../../../Services/default/userService"
import AsyncButton from "../../buttons/AsyncButton"
import FormField from "../../forms/FormField"
import ModalBasicTemplate from "../../modals/ModalBasicTemplate"
import ToogablePasswordField from "./ToogablePasswordField"
import useLogin from "../../../../hooks/defaults/useLogin"

const LoginModal = ({ show, closeFunc }) => {
	const { authPlataform: platformAuthHandler, authHandler: globalAuthHandler } = useLogin()
	const dispatch = useDispatch()
	const [pwd, setPwd] = useState("")
	const globalState = useSelector((state) => state.global)
	const { userName } = globalState
	const { companyName, companyId, company } = globalState
	const authForm = {
		email: userName,
		password: pwd,
		companyId,
		companyName,
		company,
	}

	const authHandler = async () => {
		const haveCompanyData = companyId && companyName && company

		if (!haveCompanyData) {
			await platformAuthHandler(authForm.email, authForm.password)
			dispatch(setNeedUserLogin(false))
			return true
		} else {
			const response = await globalAuthHandler(
				{ company, companyId, companyName },
				false,
				authForm.email,
				authForm.password,
				globalState.token
			)

			if (response?.token) {
				dispatch(setNeedUserLogin(false))
				closeFunc()
			} else {
				// Avoid returning true if it fails so user can try again
				setPwd("")
			}
		}
	}
	const body = () => {
		return (
			<>
				<FormField label={"Usuário"} val={userName} onValueUpdate={(v) => dispatch(setUserName(v))} />
				<ToogablePasswordField
					onChangeEvent={setPwd}
					callback={authHandler}
				/>
			</>
		)
	}
	const header = () => {
		return (
			<div className="display-flex">
				<h4>Sessão expirada</h4>
				<h5>Insira sua senha para renovar.</h5>
			</div>
		)
	}
	const footer = () => {
		return (
			<AsyncButton buttonProps={{ disabled: !pwd }} onClick={authHandler}>
				Login
			</AsyncButton>
		)
	}
	return (
		<ModalBasicTemplate
			closeFunc={closeFunc}
			show={show}
			body={body}
			props={{ keyboard: false }}
			header={header}
			footer={footer}
		/>
	)
}

export default LoginModal
